import { Card, Badge, Button } from '@atoms/index';
import type { MenuItem } from '@/types';
import { formatCurrency } from '@utils/currency';

interface MenuItemCardProps {
  item: MenuItem;
  onAddToCart: () => void;
  addToCartDisabled?: boolean;
}

const MenuItemCard = ({ item, onAddToCart, addToCartDisabled }: MenuItemCardProps) => {
  const canAdd = item.isAvailable && !addToCartDisabled;
  return (
    <Card hover padding="none" className="overflow-hidden">
      <div className="flex gap-3 p-4">
        <div className="flex-1 min-w-0">
          <h4 className="font-semibold text-gray-900 mb-1">{item.name}</h4>
          {item.description && (
            <p className="text-sm text-gray-600 mb-2 line-clamp-2">
              {item.description}
            </p>
          )}
          <div className="flex items-center gap-2 mb-3">
            <span className="font-bold text-primary">
              {formatCurrency(item.price)}
            </span>
          </div>
          {!item.isAvailable && (
            <Badge variant="danger" size="sm">
              Tükendi
            </Badge>
          )}
          {item.isAvailable && (
            <Button
              size="sm"
              variant="primary"
              onClick={onAddToCart}
              disabled={!canAdd}
              title={addToCartDisabled ? 'Restoran şu an kapalı' : undefined}
            >
              {addToCartDisabled ? 'Kapalı' : 'Sepete Ekle'}
            </Button>
          )}
        </div>

        <div className="w-24 aspect-square rounded-lg overflow-hidden bg-gray-100 flex-shrink-0">
          <img
            key={item.imageUrl ? `${item.id}-${item.imageUrl}` : item.id}
            src={item.imageUrl}
            alt={item.name}
            className="w-full h-full object-contain object-center"
          />
        </div>
      </div>
    </Card>
  );
};

export default MenuItemCard;
